<div class="at-flex" [style.display]="state() === 'inactive' ? 'none' : ''">
  <div class="">
    @if (title) {
      <div [class]="options.titleClass" [attr.aria-label]="title">
        {{ title }}
      </div>
    }
    @if (message && options.enableHtml) {
      <div
        role="alert"
        aria-live="polite"
        [class]="options.messageClass"
      [innerHTML]="message"></div>
    }
    @if (message && !options.enableHtml) {
      <div
        role="alert"
        aria-live="polite"
        [class]="options.messageClass"
        [attr.aria-label]="message">
        {{ message }}
      </div>
    }
  </div>

  @if (buttonText) {
    <button mat-button (click)="action($event)" class="toast-action-button">
      <span>{{ buttonText | uppercase }}</span>
    </button>
  }

  @if (options?.closeButton) {
    <div class="at-close-button">
      <button (click)="remove()" aria-label="Close" class="toast-close-button">
        <!-- <span aria-hidden="true" style="margin-left:20px">x</span> -->
        <mat-icon svgIcon="close" class="icon" style="margin-left: 20px; margin-top: 7px"></mat-icon>
      </button>
    </div>
  }
</div>
@if (options.progressBar) {
  <div>
    <div class="toast-progress" [style.width]="width() + '%'"></div>
  </div>
}
